// @flow
import type {Selector} from 'common/redux/types';

export const selectUserLocation: Selector<?Position> = state => state.userLocation;
